import React, { JSX } from "react";
import TracksHorizon from "@shared/assets/eds-custom-icons/Tracks-Horizon.svg?react";
import styled from "styled-components";
import { FullWidth } from "./FullWidth";
import { PlanDialog } from "@opstel/dialogs/PlanOverview/PlanDialog";

interface EmptyStateProps {
  readonly children?: JSX.Element;
}

export function EmptyState({ children }: EmptyStateProps): React.JSX.Element {
  return (
    <FullWidth style={{ minWidth: "350px" }}>
      <StyledTracksHorizonIcon />
      <GreyHeader>Er is nog geen plan om weer te geven</GreyHeader>
      <Subtext>Open een plan om te beginnen</Subtext>
      <PlanDialog buttonStyle="secondary" />
      {children}
    </FullWidth>
  );
}

const StyledTracksHorizonIcon = styled(TracksHorizon)`
  & path {
    fill: var(--tractie-color-content-default);
  }
`;

const GreyHeader = styled.div`
  font-size: var(--tractie-typography-size-xl);
  font-weight: var(--tractie-typography-weight-medium);
`;

const Subtext = styled.div`
  font-weight: var(--tractie-typography-weight-medium);
`;
